// @flow
import type {Element} from 'react'
import React from 'react'
import classNames from 'classnames'

import {SelectItems} from 'components/proposals/Part/ui'
import type {MoveItemsOptionMap, UpdateCallback} from 'components/proposals/types'
import styles from './index.scss'

type Props = $ReadOnly<{
  changeKey: string,
  isReadonly: boolean,
  isOnV5: boolean,
  roleName: string,
  onChange: UpdateCallback,
  policiesToMoveDown: MoveItemsOptionMap | $Shape<{||}>,
  rolesToMoveDown: MoveItemsOptionMap | $Shape<{||}>,
  policiesToMoveUp: MoveItemsOptionMap | $Shape<{||}>,
  rolesToMoveUp: MoveItemsOptionMap | $Shape<{||}>,
}>

function MoveItems({
  changeKey,
  isReadonly,
  isOnV5,
  roleName,
  onChange,
  policiesToMoveDown,
  rolesToMoveDown,
  policiesToMoveUp,
  rolesToMoveUp,
}: Props): Element<"div"> {
  const selectClassName = (className) => classNames(className, {[styles.selectContainer]: isOnV5})

  return (
    <div className="role-editor-move-items">
      <SelectItems
        isReadonly={isReadonly}
        title={I18n.t('proposals.circle_absorb_policies.select_policies_out', {childRole: roleName})}
        id={`${changeKey}-policies-to-move-up`}
        items={policiesToMoveUp}
        path={['policiesToMoveUp']}
        onChange={onChange}
        className={selectClassName('role-editor-move-items__policies-selector')}
      />
      <SelectItems
        isReadonly={isReadonly}
        title={I18n.t('proposals.circle_absorb_roles.select_roles_out', {childRole: roleName})}
        id={`${changeKey}-roles-to-move-up`}
        items={rolesToMoveUp}
        path={['rolesToMoveUp']}
        onChange={onChange}
        className={selectClassName('role-editor-move-items__roles-selector')}
      />
      <SelectItems
        isReadonly={isReadonly}
        title={I18n.t('proposals.circle_absorb_policies.select_policies_in', {childRole: roleName})}
        id={`${changeKey}-policies-to-move-down`}
        items={policiesToMoveDown}
        path={['policiesToMoveDown']}
        onChange={onChange}
        className={selectClassName('role-editor-move-items__policies-selector')}
      />
      <SelectItems
        isReadonly={isReadonly}
        title={I18n.t('proposals.circle_absorb_roles.select_roles_in', {childRole: roleName})}
        id={`${changeKey}-roles-to-move-down`}
        items={rolesToMoveDown}
        itemId={(role) => `test-role-${role.databaseId}-move-down`}
        path={['rolesToMoveDown']}
        onChange={onChange}
        className={selectClassName('role-editor-move-items__roles-selector')}
      />
    </div>
  )
}

MoveItems.defaultProps = {
  isReadonly: false,
  isOnV5: false,
  policiesToMoveDown: ({}: { ... }),
  rolesToMoveDown: ({}: { ... }),
  policiesToMoveUp: ({}: { ... }),
  rolesToMoveUp: ({}: { ... }),
}

export default MoveItems
